// import { BrainType, NLPBrainAction, NLPBrainModel, Slug, NLPBrainThresholds } from "@swivl/swivl-lib";
// import { NLPResponse, NLPResponseIntent } from "./methods/BrainsHandler.QueryNLP";
import { type } from 'os'
import { Slug } from '../Quests/Quest.Interfaces'
import { NLPResponse, NLPResponseIntent } from '../NLP/NLP.Model'
import {
  BrainType,
  LLMModel,
  NLPBrainAction,
  NLPBrainModel,
  NLPBrainThresholds
} from './Brain.Interface'

export interface BrainResultInterface {
  id?: string
  botId?: string
  userId: string
  createdAt?: Date
  query: string
  events: BrainResultEvent[]
  intent?: NLPResponseIntent
  brainsTriggered?: Slug[]
  handled?: boolean
  confidence?: number
  archived?: boolean
}
export type BrainResultEvent =
  | BrainResultEvent_TRIGGERED
  | BrainResultEvent_BRAIN_LOADED
  | BrainResultEvent_QUERIED_NLP
  | BrainResultEvent_PROMPTED_LLM
  | BrainResultEvent_ERROR_LOOP
  | BrainResultEvent_ERROR
  | BrainResultEvent_MISSING_GOTO
  | BrainResultEvent_UNHANDLED_TRIGGERED
  | BrainResultEvent_INTENT_TRIGGERED
  | BrainResultEvent_ENTITIES_SAVED
  | BrainResultEvent_SENT_TO_BRAIN
  | BrainResultEvent_SENT_TO_QUEST

export enum BrainResultEventType {
  TRIGGERED = 'TRIGGERED',
  BRAIN_LOADED = 'BRAIN_LOADED',
  QUERIED_NLP = 'QUERIED_NLP',
  PROMPTED_LLM = 'PROMPTED_LLM',
  ERROR_LOOP = 'ERROR_LOOP', // we hit the same brain twice
  ERROR = 'ERROR', // Generic error
  MISSING_GOTO = 'MISSING_GOTO', // Generic warning
  INTENT_TRIGGERED = 'INTENT_TRIGGERED',
  UNHANDLED_TRIGGERED = 'UNHANDLED_TRIGGERED',
  ENTITIES_SAVED = 'ENTITIES_SAVED',
  SENT_TO_BRAIN = 'SENT_TO_BRAIN',
  SENT_TO_QUEST = 'SENT_TO_QUEST'
}

interface BrainResultEventBase {
  type: BrainResultEventType
  data: any
}

export interface BrainResultEvent_TRIGGERED extends BrainResultEventBase {
  type: BrainResultEventType.TRIGGERED
  data: {
    questName: string
    questSlug: string
    nodeId?: string
    nodeType?: string
    text?: string
  }
}
export interface BrainResultEvent_BRAIN_LOADED extends BrainResultEventBase {
  type: BrainResultEventType.BRAIN_LOADED
  data: {
    slug: Slug
    name: string
    isParent: boolean
    id: string
    type: BrainType
    model: NLPBrainModel
  }
}

export interface BrainResultEvent_QUERIED_NLP extends BrainResultEventBase {
  type: BrainResultEventType.QUERIED_NLP
  data: {
    query: string
    model: NLPBrainModel
    results?: NLPResponse
  }
}

export interface BrainResultEvent_PROMPTED_LLM extends BrainResultEventBase {
  type: BrainResultEventType.PROMPTED_LLM
  data: {
    prompt: string
    model: LLMModel
    response: string
  }
}

export interface BrainResultEvent_ERROR_LOOP extends BrainResultEventBase {
  type: BrainResultEventType.ERROR_LOOP
  data: {
    brainsTriggered: Slug[]
  }
}
export interface BrainResultEvent_ERROR extends BrainResultEventBase {
  type: BrainResultEventType.ERROR
  data: {
    message: string
    data?: any
  }
}
export interface BrainResultEvent_MISSING_GOTO extends BrainResultEventBase {
  type: BrainResultEventType.MISSING_GOTO
  data: {
    message: string
    action?: any
  }
}

export interface BrainResultEvent_UNHANDLED_TRIGGERED extends BrainResultEventBase {
  type: BrainResultEventType.UNHANDLED_TRIGGERED
  data: {
    action: NLPBrainAction
  }
}

export interface BrainResultEvent_INTENT_TRIGGERED extends BrainResultEventBase {
  type: BrainResultEventType.INTENT_TRIGGERED
  data: {
    thresholds: NLPBrainThresholds
    score: number
    action: NLPBrainAction
  }
}

export interface BrainResultEvent_ENTITIES_SAVED extends BrainResultEventBase {
  type: BrainResultEventType.ENTITIES_SAVED
  data: {
    thresholds: NLPBrainThresholds
    entities: { [entity: string]: { value: string; score: number } } // Entity Name, Entity Value
  }
}

export interface BrainResultEvent_SENT_TO_BRAIN extends BrainResultEventBase {
  type: BrainResultEventType.SENT_TO_BRAIN
  data: {
    brain: {
      slug: Slug
      isParent: boolean
      name: string
    }
  }
}

export interface BrainResultEvent_SENT_TO_QUEST extends BrainResultEventBase {
  type: BrainResultEventType.SENT_TO_QUEST
  data: {
    quest: {
      slug: Slug
      isParent: boolean
      name: string
    }
  }
}
